import '../../styles/faq.css'
import FeedbackIcons from '../../Containers/FeedbackIcons'
import TextWithHttpsLinks from './TextWithHttpsLinks'
import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'

const FaqComponent = ({ faq, expandedFaqResultId, toggleFaq, queryId }) => {
    const [feedbackData, setFeedbackData] = useState({})

    const handleToggleFaq = (resultId) => () => toggleFaq(resultId)

    const handleFeedback = (resultId, isRelevant, message) => {
        setFeedbackData(prev => ({
            ...prev,
            [resultId]: { isRelevant, message }
        }))
    }

    return (
        <div className="faq-container">
            {faq.message && <p>{faq.message}</p>}
            {faq.faqs.map((faqItem) => (
                <div key={faqItem.resultId} className="faq-item">
                    <div
                        className={`faq-question ${expandedFaqResultId === faqItem.resultId ? 'expanded' : ''}`}
                        onClick={handleToggleFaq(faqItem.resultId)}
                        tabIndex="0"
                        onKeyDown={(e) => e.key === 'Enter' && handleToggleFaq(faqItem.resultId)()}
                    >
                        <span>{faqItem.question}</span>
                        <FontAwesomeIcon
                            icon={expandedFaqResultId === faqItem.resultId ? faChevronUp : faChevronDown}
                            className="faq-icon"
                        />
                    </div>
                    {expandedFaqResultId === faqItem.resultId && (
                        <div className="faq-answer">
                            <TextWithHttpsLinks text={faqItem.answer} />
                            <FeedbackIcons queryId={queryId} resultId={faqItem.resultId} feedback={feedbackData[faqItem.resultId]} onFeedback={handleFeedback} />
                        </div>
                    )}
                </div>
            ))}
        </div>
    )
}

export default FaqComponent